import { render } from "./SearchModal_Kojin.vue?vue&type=template&id=5051596c"
import script from "./SearchModal_Kojin.vue?vue&type=script&lang=js"
export * from "./SearchModal_Kojin.vue?vue&type=script&lang=js"

import "./SearchModal_Kojin.vue?vue&type=style&index=0&id=5051596c&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__